import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCOhjEOTxUo8gInj2wcMjvyfLILOIeWujw",
  authDomain: "veezee-86fc0.firebaseapp.com",
  projectId: "veezee-86fc0",
  storageBucket: "veezee-86fc0.appspot.com",
  messagingSenderId: "849632246060",
  appId: "1:849632246060:web:c51a93842ebef3ac821489",
  measurementId: "G-8LTMP7GBYE"
};

export const app = initializeApp(firebaseConfig);